import { TabbableModeContext } from '#hooks/UNSAFE_useTabbableMode';
import type { TestIdProps } from '#hooks/UNSAFE_useTestId';
import { useTranslationBundle } from '#hooks/UNSAFE_useTranslationBundle';
import { DeleteIcon } from '#PRIVATE_ThemedIcons/DeleteIcon';
import type { BundleType } from '#resources/nls/bundle';
import { IconButton } from '#UNSAFE_IconButton';

type Props = {
  onClick?: () => void;
} & TestIdProps;

const preventFocusTransfer: EventListener = (event) => event.preventDefault();

/**
 * ClearIcon is used to clear an input value.
 * @param onClick Callback for clearing value when button is clicked
 * @param testId ID used for testing purposes
 */
export function ClearIcon({ onClick, testId }: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const clearStr = translations.formControl_clear();

  return (
    <TabbableModeContext.Provider value={{ isTabbable: false }}>
      {/*
        JET-74048 - onValueChanged prop getting triggered if clear icon is clicked twice
        If the clear icon takes focus, it triggers a change event in the component as this will
        trigger a blur event. So, we force the clear icon to not take focus when clicking on it
        using pointers. For keyboard, this is not tabbable so no need to do anything there.
       */}
      <div aria-hidden="true" onMouseDown={preventFocusTransfer}>
        <IconButton variant="ghost" size="sm" onAction={onClick} tooltip={clearStr} testId={testId}>
          <DeleteIcon />
        </IconButton>
      </div>
    </TabbableModeContext.Provider>
  );
}
